// ==================== 配置项（请替换为实际值） ====================
const MH_PAGE_API_BASE = "https://mh-pagedata.luc-canopus.workers.dev"; // 你的Worker地址
const REQUEST_TIMEOUT = 15000; // 请求超时时间（15秒）
// ==================================================================

/**
 * 校验并获取当前页面的 Page ID
 * @returns {string|null} Page ID 或 null
 */
function ensurePageId() {
  const pageId = window.__PAGE_ID__;
  if (!pageId) return null;
  return pageId;
}

/**
 * 创建请求控制器（超时自动中止）
 * @returns {AbortController}
 */
function createRequestController() {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), REQUEST_TIMEOUT);
  return controller;
}

/**
 * 通用请求封装
 * @param {string} url 请求地址
 * @param {Object} options fetch配置
 * @returns {Promise<Object>} 接口返回的JSON数据
 */
async function request(url, options) {
  const controller = createRequestController();
  try {
    const res = await fetch(url, {
      ...options,
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

    const data = await res.json();
    if (!res.ok || !data.ok) {
      throw new Error(data.error || `请求失败（HTTP ${res.status}）`);
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      throw new Error(`请求超时（超过${REQUEST_TIMEOUT/1000}秒）`);
    }
    throw new Error(`接口异常：${err.message}`);
  }
}

// 生产环境核心API
window.mhPageData = {
  /**
   * 读取当前Page的元字段值
   * @returns {Promise<Object|null>} 元字段值（无数据返回null）
   */
  async read() {
    const pageId = ensurePageId();
    if (!pageId) throw new Error("当前页面无有效Page ID");

    const url = `${MH_PAGE_API_BASE}?owner_resource=page&owner_id=${pageId}`;
    const data = await request(url, { method: "GET" });
    return data.value;
  },

  /**
   * 覆盖写入当前Page的元字段（仅支持普通JSON对象）
   * @param {Object} obj 要写入的对象（不能是null/数组/基本类型）
   * @returns {Promise<Object>} 写入后的对象
   */
  async write(obj) {
    const pageId = ensurePageId();
    if (!pageId) throw new Error("当前页面无有效Page ID");

    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      throw new Error("写入值必须是普通JSON对象（如 {key: 'value'}）");
    }

    const data = await request(MH_PAGE_API_BASE, {
      method: "POST",
      body: JSON.stringify({
        owner_resource: "page",
        owner_id: pageId,
        value: obj,
      }),
    });
    return data.value;
  },

  /**
   * 增量更新元字段（读→合并→写）
   * @param {Function} updater 更新函数，接收当前值返回新值
   * @returns {Promise<Object>} 更新后的对象
   */
  async update(updater) {
    const pageId = ensurePageId();
    if (!pageId) throw new Error("当前页面无有效Page ID");
    if (typeof updater !== "function") {
      throw new Error("更新函数必须是Function类型");
    }

    // 先读旧值，再合并更新
    const current = (await this.read()) || {};
    const next = updater(current);
    
    // 校验更新后的值
    if (typeof next !== "object" || next === null || Array.isArray(next)) {
      throw new Error("更新函数返回值必须是普通JSON对象");
    }

    return this.write(next);
  },
};